export default __webpack_public_path__ + "static/media/lifestyle-connected.f6c5756c.jpg";